import type { PolicyType } from "./policy-copy";

export const POLICY_TOGGLEABLE_STEP_TYPES: Partial<Record<PolicyType, readonly string[]>> = {
  request_metadata_edit: ["remove_from_linked_collab"],
};
